var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-open-content",attrs:{"id":"tpl-statement"}},[_c('b-container',[_c('b-card',{attrs:{"no-body":""},domProps:{"innerHTML":_vm._s(_vm.candidate.openContent)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }